import React from "react";
import PolicyEmbed from "./PolicyEmbed";

export default function DSARPage() {

  return <PolicyEmbed title="Data Subject Access Request"
                      src="https://app.termly.io/dsar/17afab85-64a4-411e-8248-3acc224f0214"
                      height={1300} />

}
